module.exports = __webpack_public_path__ + "assets/images/template/project/sars_wuhan_comparison/tablet.svg?v=ce62ed3b";